import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../services/workplace.service';
import { WorkplaceAddressGridObject } from '@it2go/types';

interface State {
    workplaceAddresses: WorkplaceAddressGridObject | null;
}

const defaultState: State = {
    workplaceAddresses: null,
};

@Injectable()
export class WorkplaceDetailAddressesStore extends ComponentStoreFactory<State> {

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
    }

}
